



































import { Vue, Component, Prop, PropSync, Ref, Watch } from 'vue-property-decorator'
import type { CreditosDoCliente, TipoDePagamento, Venda } from '@/models'
import CardDeTipoDePagamento from './CardDeTipoDePagamento.vue'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'

@Component({
	components: {
		CardDeTipoDePagamento,
	},
})
export default class MatrizDeTiposDePagamento extends Vue {
	@PropSync('value', { type: Object, default: null }) TipoDePagamento!: TipoDePagamento | null
	@PropSync('paginaAtual', { type: Number, default: 0 }) paginaAtualSync!: number
	@Prop({ type: Array, default: () => [] }) tiposDePagamento!: TipoDePagamento[]
	@Ref() cards!: CardDeTipoDePagamento[]
	@Prop() creditosDoCliente!: CreditosDoCliente
	@Prop({ type: Boolean }) desabilitarCartoes?: boolean
	@Prop({ type: Array, default: () => [] }) tiposDePagamentoBloqueados!: TipoDePagamento[]
	@Prop({ type: Boolean }) existeItemValePresente!: boolean
	@Prop({ type: Boolean }) pagamentoMaiorQueVenda!: boolean
	@Prop({ type: Boolean, default: false }) mostraTelaDePagamento!: boolean

	vendaConferidaPorRfid = JSON.parse(localStorage.getItem('VENDA_CONFERIDA_POR_RFID') || 'false')

	@Watch('mostraTelaDePagamento', { immediate: true })
	onChangeMostraTelaPagamento(mostra: boolean) {
		if (mostra) {
			document.addEventListener('keydown', this.atalhoDeFormaDePagamento)
			document.addEventListener('keydown', this.atalhoDeOutrosTiposDePagamento)
		} else {
			document.removeEventListener('keydown', this.atalhoDeFormaDePagamento)
			document.removeEventListener('keydown', this.atalhoDeOutrosTiposDePagamento)
		}
	}

	destroyed() {
		document.removeEventListener('keydown', this.atalhoDeFormaDePagamento)
		document.removeEventListener('keydown', this.atalhoDeOutrosTiposDePagamento)
	}

	atalhoDeFormaDePagamento(event: KeyboardEvent) {
		if (event.altKey && event.key.toLowerCase().match(/[1-9]/)) {
			event.preventDefault()
			event.stopPropagation()

			const indice = Number(event.key) -1
			if (!this.tiposDePagamento[indice]) return

			const tipoDePagamentoBloqueado = this.tiposDePagamentoBloqueados.some((bloqueado) => bloqueado.id === this.tiposDePagamento[indice].id)
			if(tipoDePagamentoBloqueado){
				AlertModule.setWarning(`Tipo de pagamento ${this.tiposDePagamento[indice].nome} está bloqueado para o cliente.`)
				return 
			}

			if (this.pagamentoBloqueadoParaRfid(this.tiposDaPaginaAtual[indice])) 
				return AlertModule.setWarning(`Tipo de pagamento ${this.tiposDaPaginaAtual[indice].nome} está bloqueado para venda com leitura RFID.`)

			if (this.tiposDaPaginaAtual[indice].formaDePagamento === 'Crediário' && this.venda.cliente === null && this.venda.cpfDoCliente === "") return

			const documentoAtivo: any | undefined = document.activeElement

			if (documentoAtivo?.blur) documentoAtivo.blur()
			if (!this.cards[indice]) return
			this.cards[indice].click()
		}
	}

	atalhoDeOutrosTiposDePagamento(event: KeyboardEvent) {
		if (event.altKey && event.key === 'o') {
			event.preventDefault()
			event.stopPropagation()
			this.irParaProximaPaginaDeTipos()
		}
	}

	irParaProximaPaginaDeTipos() {
		this.paginaAtualSync = (this.paginaAtualSync + 1) % this.totalDePaginas
	}

	get venda() {
		return VendaModule.vendaAtual as Venda
	}
	
	set venda(venda: Venda) {
		VendaModule.setVendaAtual(venda)
	}

	get totalDePaginas() {
		return Math.ceil(this.tiposDePagamento.length / this.pagamentosPorPagina)
	}

	get tiposDaPaginaAtual() {
		const inicio = this.paginaAtualSync * this.pagamentosPorPagina
		return this.venda.isConsignado && !this.venda.isVendaReaberta 
			? this.tiposDePagamento.slice(inicio, inicio + this.pagamentosPorPagina).filter(tipo => tipo.formaDePagamento === 'Consignado') 
			: this.tiposDePagamento.slice(inicio, inicio + this.pagamentosPorPagina)
	}

	get pagamentosPorPagina() {
		return this.$vuetify.breakpoint.mdAndUp
			? 9
			: 4
	}
	
	get possuiItemParaVenda() {
		return VendaModule.vendaAtual?.itens.some(item => item.isCompra) || false;
	}

	get temPagamentoQueGeraDuplicatas() {
		return VendaModule.vendaAtual?.pagamentos.some(pagamento => pagamento.tipoDePagamento.exibirNasDuplicatasDaDanfe) || false
	}

	get temPagamentoQueNaoGeraDuplicatas() {
		return VendaModule.vendaAtual?.pagamentos.some(pagamento => !pagamento.tipoDePagamento.exibirNasDuplicatasDaDanfe) || false
	}

	validarTipoPagamentoAtivo(tipoDePagamento: TipoDePagamento): boolean | undefined {
		const tipoDePagamentoBloqueado = this.tiposDePagamentoBloqueados.some((bloqueado) => bloqueado.id === tipoDePagamento.id);

		if (tipoDePagamentoBloqueado) { return true; }
		if (typeof this.creditosDoCliente.voucher !== 'number' || typeof this.creditosDoCliente.crediario !== 'number') return undefined
		if (tipoDePagamento.formaDePagamento === 'Voucher' && !this.creditosDoCliente.voucher) return true
		if (tipoDePagamento.formaDePagamento === 'Crediário'){
			if (this.creditosDoCliente.crediario <= 0 && !UserLoginStore.permiteRegraDeNegocio('permite-vendas-acima-do-valor-limite-do-funcionario')) {
				return true
			} else if (this.pagamentoMaiorQueVenda) {
				return true
			} else if (this.venda.cliente === null && this.venda.cpfDoCliente === "") {
				return true
			}
		}
		if (tipoDePagamento.formaDePagamento === 'TEF Crédito' && (!VendaModule.turnoDeVenda?.pontoDeVenda.loja.configuracaoDaLoja?.integracaoControlPayAtiva && !VendaModule.turnoDeVenda?.pontoDeVenda.loja.configuracaoDaLoja?.integracaoSitefAtiva)) return true
		if (tipoDePagamento.formaDePagamento === 'TEF Débito' && (!VendaModule.turnoDeVenda?.pontoDeVenda.loja.configuracaoDaLoja?.integracaoControlPayAtiva && !VendaModule.turnoDeVenda?.pontoDeVenda.loja.configuracaoDaLoja?.integracaoSitefAtiva)) return true
		if (this.desabilitarCartoes && tipoDePagamento.formaDePagamento === 'Cartão') return false
		if (tipoDePagamento.formaDePagamento === 'Consignado' && !VendaModule.vendaAtual?.isConsignado) return true
		if (tipoDePagamento.formaDePagamento === 'Demonstração' && !VendaModule.vendaAtual?.isDemonstracao) return true
		if(tipoDePagamento.formaDePagamento === 'Demonstração' && 
			VendaModule.vendaAtual?.isVendaReaberta &&
				VendaModule.vendaAtual?.isDemonstracao && this.possuiItemParaVenda) return true
		if((this.temPagamentoQueGeraDuplicatas && !tipoDePagamento.exibirNasDuplicatasDaDanfe) || 
		(this.temPagamentoQueNaoGeraDuplicatas && tipoDePagamento.exibirNasDuplicatasDaDanfe)) return true
		if(this.existeItemValePresente && tipoDePagamento.formaDePagamento === 'Vale Presente') return true
		if (this.pagamentoBloqueadoParaRfid(tipoDePagamento)) return true
		
		return false
	}

	obterValorDisponivel(tipoDePagamento: TipoDePagamento): number | undefined {
		if (tipoDePagamento.formaDePagamento === 'Voucher') return this.creditosDoCliente.voucher
		if (tipoDePagamento.formaDePagamento === 'Crediário') return this.creditosDoCliente.crediario
		if (tipoDePagamento.valorLimitePorCompra > 0 && tipoDePagamento.valorLimitePorCompra != null){
			const pagamentosDaVendaAtual = this.venda.pagamentos.filter(pagamento => pagamento.tipoDePagamento.id === tipoDePagamento.id)
			const totalPago = pagamentosDaVendaAtual.reduce((soma, pagamento) => soma + (pagamento.valor ?? 0), 0)

			return Math.max(0, tipoDePagamento.valorLimitePorCompra - totalPago)
		}

		return undefined
	}

	async input(tipoDePagamento: TipoDePagamento) {
		this.$emit('input', tipoDePagamento)
	}

	pagamentoBloqueadoParaRfid(tipo: TipoDePagamento): boolean {
		if (!this.vendaConferidaPorRfid) return false

		const pagamentosBloqueadosRfid: any[] =
			VendaModule.turnoDeVenda?.pontoDeVenda?.formasDePagamentoRfid ?? []

		const id = tipo.id;
		const nome = tipo.formaDePagamento

		return pagamentosBloqueadosRfid.some((p: any) => {
			const pid = typeof p === 'object' ? p.id : (typeof p === 'number' ? p : undefined)
			const pnome = typeof p === 'object' ? p.formaDePagamento : (typeof p === 'string' ? p : undefined)

			return (pid !== undefined && pid === id) ||
				(pnome !== undefined && pnome === nome)
		})
	}
}

